import { Component, OnInit } from '@angular/core';
import { HeaderService } from '@app/service/header/header.service';
import { StateControlParameters, StateService, ZaverProduct } from '@app/service/state/state.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteComponent } from '@app/route/route.component';

@Component({
  selector: 'se-connect-to-bank-start',
  templateUrl: './se-connect-to-bank-start.component.html',
  styleUrls: ['./se-connect-to-bank-start.component.scss', '../../page-shared.css', ],
})
export class SeConnectBankStart extends RouteComponent implements OnInit {
  constructor(
    protected stateService: StateService,
    protected headerService: HeaderService,
    protected router: Router,
    protected route: ActivatedRoute
  ) {
    super(router, route, stateService, headerService);
  }
  useIframe: boolean;
  loading: boolean = true;

  async ngOnInit(): Promise<void> {
    this.loading = false;
  }

  confirm(): void {
    this.navigate();
  }
  
  backNavigationAllowed(): boolean {
    const checkoutProducts = [
      ZaverProduct.ECOM_CHECKOUT,
      ZaverProduct.IN_STORE_CHECKOUT
    ];
    return checkoutProducts.includes(this.state.zaverProduct);
  }
  
  async reroute(): Promise<void> {
    const path: string = this.route.routeConfig.path;

    const controlParams: StateControlParameters = {
      currentPageName: this.stateService.getStepFromUrl(path),
      token: this.stateService.getToken(),
    };

    this.state = await this.stateService.reset(controlParams);
    const route = this.stateService.getRouteFromState(this.state);
    this.router.navigate([route], { queryParamsHandling: 'preserve' });
  }
}
